"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const account_habit_1 = require("./account-habit");
const base_1 = __importDefault(require("./base"));
const container_1 = __importDefault(require("./container"));
const defaults_1 = require("./defaults");
class Phase extends base_1.default {
    constructor(data = {
        id: undefined,
        title: undefined,
        subtitle: undefined,
        friendly_name: undefined,
        containers: [],
    }) {
        var _a;
        super(data);
        this.id = (0, defaults_1.defaultString)(data.id);
        this.title = (0, defaults_1.defaultString)(data.title);
        this.subtitle = (0, defaults_1.defaultString)(data.subtitle);
        this.friendly_name = (0, defaults_1.defaultString)(data.friendly_name);
        this.containers = (0, defaults_1.defaultArray)((_a = data.containers) === null || _a === void 0 ? void 0 : _a.map((cont) => new container_1.default(cont)));
    }
    getStatus(accountSegments, accountHabit) {
        if (accountHabit && accountHabit.unlockedManually) {
            return account_habit_1.HabitStates.COMPLETE;
        }
        const completed = this.containers.every((container) => container.getStatus(accountSegments) === account_habit_1.HabitStates.COMPLETE);
        if (completed)
            return account_habit_1.HabitStates.COMPLETE;
        const active = this.containers.some((container) => container.getStatus(accountSegments) === account_habit_1.HabitStates.ACTIVE
            || container.getStatus(accountSegments) === account_habit_1.HabitStates.COMPLETE);
        if (active)
            return account_habit_1.HabitStates.ACTIVE;
        return account_habit_1.HabitStates.LOCKED;
    }
    getSegmentList() {
        return this.containers.reduce((acc, comp) => [...acc, ...comp.segments], []);
    }
}
exports.default = Phase;
